import { GehaLogo } from './GehaLogo/GehaLogo';
import { GehaV2Logo } from './GehaV2Logo/GehaV2Logo';
import { UmrLogo } from './UmrLogo/UmrLogo';

export { GehaLogo, GehaV2Logo, UmrLogo };
